// @ts-strict-ignore
// import { useUserPermissions } from "@dashboard/auth/hooks/useUserPermissions";
// import { ListFilters } from "@dashboard/components/AppLayout/ListFilters";
import { TopNav } from "@dashboard/components/AppLayout/TopNav";
// import { BulkDeleteButton } from "@dashboard/components/BulkDeleteButton";
// import { ButtonGroupWithDropdown } from "@dashboard/components/ButtonGroupWithDropdown";
import { FilterPresetsSelect } from "@dashboard/components/FilterPresetsSelect";
import { Vendors } from "@dashboard/vendors/types";
import { VendorListUrlSortField, vendorUrl } from "@dashboard/vendors/urls";
import { extensionMountPoints } from "@dashboard/extensions/extensionMountPoints";
import {
  // getExtensionItemsForOverviewCreate,
  getExtensionsItemsForCustomerOverviewActions,
} from "@dashboard/extensions/getExtensionsItems";
import { useExtensions } from "@dashboard/extensions/hooks/useExtensions";
// import { useFlag } from "@dashboard/featureFlags";
// import useNavigator from "@dashboard/hooks/useNavigator";
import { sectionNames } from "@dashboard/intl";
import { FilterPagePropsWithPresets, PageListProps, SortPage } from "@dashboard/types";
import { Box, ChevronRightIcon } from "@saleor/macaw-ui-next";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { VendorListDatagrid } from "../VendorListDataGrid/VendorListDatagrid";
import { createFilterStructure, VendorFilterKeys, VendorListFilterOpts } from "./filters";

export interface VendorListPageProps
  extends PageListProps,
    FilterPagePropsWithPresets<VendorFilterKeys, VendorListFilterOpts>,
    SortPage<VendorListUrlSortField> {
  vendors: Vendors | undefined;
  selectedVendorIds: string[];
  loading: boolean;
  onSelectVendorIds: (rows: number[], clearSelection: () => void) => void;
  onVendorsDelete: () => void;
  /**
   * Called when user clicks the "View" action in the Actions column.
   */
  onViewVendor?: (id: string) => void;
}

const VendorListPage = ({
  selectedFilterPreset,
  filterOpts,
  initialSearch,
  onFilterPresetsAll,
  onFilterChange,
  onFilterPresetDelete,
  onFilterPresetUpdate,
  onSearchChange,
  onFilterPresetChange,
  onFilterPresetPresetSave,
  filterPresets,
  selectedVendorIds,
  hasPresetsChanged,
  onVendorsDelete,
  onViewVendor,
  ...vendorListProps
}: VendorListPageProps) => {
  const intl = useIntl();
  // const navigate = useNavigator();
  // const userPermissions = useUserPermissions();
  // const structure = createFilterStructure(intl, filterOpts, userPermissions);
  const [isFilterPresetOpen, setFilterPresetOpen] = useState(false);
  // const { enabled: isVendorsFiltersEnabled } = useFlag("new_filters");
  const { CUSTOMER_OVERVIEW_MORE_ACTIONS } = useExtensions(extensionMountPoints.CUSTOMER_LIST);
  const extensionMenuItems = getExtensionsItemsForCustomerOverviewActions(
    CUSTOMER_OVERVIEW_MORE_ACTIONS,
    selectedVendorIds,
  );
  // const extensionCreateButtonItems = getExtensionItemsForOverviewCreate(CUSTOMER_OVERVIEW_CREATE);

  return (
    <>
      <TopNav title={intl.formatMessage(sectionNames.vendors)} withoutBorder isAlignToRight={false}>
        <Box __flex={1} display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex">
            <Box marginX={5} display="flex" alignItems="center">
              <ChevronRightIcon />
            </Box>
            <FilterPresetsSelect
              presetsChanged={hasPresetsChanged()}
              onSelect={onFilterPresetChange}
              onRemove={onFilterPresetDelete}
              onUpdate={onFilterPresetUpdate}
              savedPresets={filterPresets}
              activePreset={selectedFilterPreset}
              onSelectAll={onFilterPresetsAll}
              onSave={onFilterPresetPresetSave}
              isOpen={isFilterPresetOpen}
              onOpenChange={setFilterPresetOpen}
              selectAllLabel={intl.formatMessage({
                id: "D95l71",
                defaultMessage: "All vendors",
                description: "tab name",
              })}
            />
          </Box>
          <Box display="flex" alignItems="center" gap={2}>
            {extensionMenuItems.length > 0 && <TopNav.Menu items={extensionMenuItems} />}
            {/* {extensionCreateButtonItems.length > 0 ? (
              <ButtonGroupWithDropdown
                options={extensionCreateButtonItems}
                data-test-id="create-vendor"
                onClick={() => navigate(vendorAddUrl)}
              >
                <FormattedMessage
                  id="QLVddq"
                  defaultMessage="Create vendor"
                  description="button"
                />
              </ButtonGroupWithDropdown>
            ) : (
              <Button data-test-id="create-vendor" onClick={() => navigate(vendorAddUrl)}>
                <FormattedMessage
                  id="QLVddq"
                  defaultMessage="Create vendor"
                  description="button"
                />
              </Button>
            )} */}
          </Box>
        </Box>
      </TopNav>
      <Box>
        {/* {isVendorsFiltersEnabled ? (
          <ListFilters
            type="expression-filter"
            initialSearch={initialSearch}
            searchPlaceholder={intl.formatMessage({
              id: "kdRcqU",
              defaultMessage: "Search vendors...",
            })}
            onSearchChange={onSearchChange}
            actions={
              <Box display="flex" gap={4}>
                {selectedVendorIds.length > 0 && (
                  <BulkDeleteButton onClick={onVendorsDelete}>
                    <FormattedMessage defaultMessage="Delete vendors" id="kFsTMN" />
                  </BulkDeleteButton>
                )}
              </Box>
            }
          />
        ) : (
          <ListFilters
            filterStructure={structure}
            initialSearch={initialSearch}
            searchPlaceholder={intl.formatMessage({
              id: "kdRcqU",
              defaultMessage: "Search vendors...",
            })}
            onFilterChange={onFilterChange}
            onSearchChange={onSearchChange}
            actions={
              <Box display="flex" gap={4}>
                {selectedVendorIds.length > 0 && (
                  <BulkDeleteButton onClick={onVendorsDelete}>
                    <FormattedMessage defaultMessage="Delete vendors" id="kFsTMN" />
                  </BulkDeleteButton>
                )}
              </Box>
            }
          />
        )} */}
        <VendorListDatagrid
          {...vendorListProps}
          hasRowHover={false}
          // IMPORTANT: Row navigation disabled by not passing rowAnchor / navigation handler.
          onViewVendor={onViewVendor}
        />
      </Box>
    </>
  );
};

VendorListPage.displayName = "VendorListPage";
export default VendorListPage;
